/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Th5Inputs */

const en_mk_cmp_notion_th5 = /** @type {(inputs: Mk_Cmp_Notion_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a conversation tool; comments attach to pages.`)
};

const id_mk_cmp_notion_th5 = /** @type {(inputs: Mk_Cmp_Notion_Th5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukan alat percakapan; komentar menempel pada halaman.`)
};

/**
* | output |
* | --- |
* | "Not a conversation tool; comments attach to pages." |
*
* @param {Mk_Cmp_Notion_Th5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_th5 = /** @type {((inputs?: Mk_Cmp_Notion_Th5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Th5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_th5(inputs)
	return en_mk_cmp_notion_th5(inputs)
});